export default __webpack_public_path__ + "static/char-s-31-en-51fe8d3b6db827fe6250b3adb74565c5.webp";